import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface WalletOptionProps {
  id: number;
  name: string;
  status: number;
}

export const WalletOption = ({ id, name, status }: WalletOptionProps) => {
  const { t } = useTranslation();
  const isActive = status === 1;

  return (
    <StyledWalletOption>
      <StyledWalletName>{`${id} | ${name}`}</StyledWalletName>
      <StyledChip status={isActive}>
        {isActive ? t("Вкл") : t("Выкл")}
      </StyledChip>
    </StyledWalletOption>
  );
};

export const createWalletOption = (wallet: {
  id: number;
  name: string;
  status: number;
}) => ({
  value: `${wallet.id}`,
  label: (
    <WalletOption id={wallet.id} name={wallet.name} status={wallet.status} />
  ),
  searchLabel: `${wallet.id} | ${wallet.name}`,
});

const StyledWalletOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

const StyledWalletName = styled.span`
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
  font-size: 13px
`;

export const StyledChip = styled.div<{
  status: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  height: 22px;
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
  margin-left: 8px;
  border-radius: 20px;
  background: ${(props) => (props.status ? "#3ea959" : "#d00025")};
  color: #fff;
  width: max-content;
`;
